import { dcrfClient } from '../../app/api'
import { logger } from '../../app/logging';
import {
    IISOTPEndpointScanRun,
    ICreateISOTPEndpointScanRun
} from './ISOTPEndpointScanRunsSlice';

const wsStream = 'isotpendpointscanrun'

export const fetchAllISOTPEndpointScanRunsViaDCRF = () => {
    logger.debug('fetchAllISOTPEndpointScanRunsViaDCRF')
    return dcrfClient.list(wsStream)
}

export const patchISOTPEndpointScanRunViaDCRF = (id: number, data: any) => {
    logger.debug(`patchISOTPEndpointScanRunViaDCRF with id: ${id} - data: ${data}`)
    return dcrfClient.patch(wsStream, id, data)
}

export const createISOTPEndpointScanRunViaDCRF = (newScanRun: ICreateISOTPEndpointScanRun) => {
    logger.debug(`createISOTPEndpointScanRunViaDCRF with hw_interface: ${newScanRun.hw_interface}`)
    return dcrfClient.create(wsStream, newScanRun)
}

export const deleteISOTPEndpointScanRunViaDCRF = (id: number) => {
    logger.debug(`deleteISOTPEndpointScanRunViaDCRF with id: ${id}`)
    return dcrfClient.delete(wsStream, id)
}

export const subscribeToISOTPEndpointScanRunChangesViaDCRF = (callback: (scanRun: IISOTPEndpointScanRun | undefined, action: string) => void) => {
    logger.debug('subscribeToISOTPEndpointScanRunChangesViaDCRF')

    // NOTE: also subscribe to the scan run findings here because although a scan run holds a list of findings
    //       any change to a finding (or adding one) will not send a notification for the associated scan run
    //       (the backend handles this now, keep this as "documentation" until it is clear that the backend change does not break anything)
    //dcrfClient.subscribe('isotpendpointscanrunfinding',
    //    {},
    //    (scanRunFinding, action) => {
    //        // we do not care about the data, just re-fetch all scan runs
    //        callback(undefined, 'force-refetch')
    //    },
    //    {
    //        includeCreateEvents: true,
    //        subscribeAction: 'subscribe_to_all_changes',
    //        unsubscribeAction: 'unsubscribe_from_all_changes',
    //    }
    //)

    const subscription = dcrfClient.subscribe(wsStream,
        {},
        (scanRun, action) => {
            callback(scanRun as IISOTPEndpointScanRun, action)
        },
        {
            includeCreateEvents: true,
            requestId: 'subscribeToISOTPEndpointScanRunChangesViaDCRF',
            subscribeAction: 'subscribe_to_all_changes',
            unsubscribeAction: 'unsubscribe_from_all_changes',
        }
    )
    // a subscription can be canceled by calling "cancel" on the returned subscription object
    return subscription
}
